export const handleLaboratory = (product, className) => {
	if (!product.laboratory) {
		return <label className={className}> </label>;
	}

	return <label className={className}>{product.laboratory}</label>;
};
